import { authService } from '@services'

const goToOldVersion = () => {
  const oldVersionUrl = process.env.REACT_APP_OLD_REACT_SITE_URL
  const token = authService.getToken()
  window.location.replace(`${oldVersionUrl}/login?token=${token}`)
}

export default goToOldVersion